<template>
    <div class="w-full h-full flex justify-center items-center">
        <img
            v-show="imageCropped"
            :src="imageCropped"
            :srcset="`${imageCropped2x} 2x, ${imageCropped} 1x`"
            alt="Whiskey Bottle"
            class="object-cover w-full h-full bottle-image"
            :class="{ 'md:-translate-x-1/4 lg:-translate-x-1/3': isReviewStep }"
        >
    </div>
</template>

<style>
    /* Tablet (md breakpoint) portrait orientation */
    @media screen and (min-width: 768px) and (orientation: portrait) {
        #cz3 .bottle-image {
            @apply !object-none;
        }
    }
</style>

<script>
    import * as constants from '../constants';
    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        computed: {
            isMobile() {
                return this.appStore.isMobile;
            },

            currentStep() {
                return this.appStore.currentStep;
            },

            currentImage() {
                return this.customizerStore.currentImage;
            },

            isPersonalizeStep() {
                return this.currentStep === constants.STEP_PERSONALIZE;
            },

            isReviewStep() {
                return this.currentStep === constants.STEP_REVIEW;
            },

            controller() {
                return this.customizerStore.viewController;
            },

            rpos() {
                const position = this.isMobile ? '1100' : '1000';

                return `&rpos=0,${position}`;
            },

            baseWidth() {
                return 3890 / 2;
            },

            rsize() {
                const size = this.isMobile ? '1400' : '1600';

                return `&rsize=${this.baseWidth * 2},${size}`;
            },

            defaultHeight() {
                if (this.isMobile) {
                    return 355;
                }

                return 800;
            },

            doubleHeight() {
                return this.defaultHeight * 2;
            },

            defaultWidth() {
                if (this.isMobile) {
                    return this.baseWidth / 2;
                }

                return this.baseWidth;
            },

            doubleWidth() {
                return this.defaultWidth * 2;
            },

            imageCropped() {
                if (this.currentImage === '') {
                    return this.currentImage;
                }

                const rwid = `&rwid=${this.defaultWidth}`;
                const rhei = `&rhei=${this.defaultHeight}`;

                return `${this.currentImage}${rwid}${rhei}${this.rpos}${this.rsize}`;
            },

            imageCropped2x() {
                if (this.currentImage === '') {
                    return this.currentImage;
                }

                const rwid = `&rwid=${this.doubleWidth}`;
                const rhei = `&rhei=${this.doubleHeight}`;

                return `${this.currentImage}${rwid}${rhei}${this.rpos}${this.rsize}`;
            },
        },

        watch: {
            controller() {
                this.customizerStore.setCurrentImage();

                this.controller.on('stateChanged', () => {
                    this.customizerStore.setCurrentImage();
                });
            },

            currentStep() {
                if (this.isPersonalizeStep) {
                    this.customizerStore.setCurrentImage();
                }
            },
        },
    };
</script>
